import 'core-js/fn/array/from';
import 'core-js/';
import 'core-js/es6/symbol';
import 'core-js/fn/symbol/iterator';
import 'promise-polyfill/src/polyfill';
import 'focus-visible/dist/focus-visible';

// ie11 node remove polyfill
function nodeRemove() {
  if (this.parentNode) {
    this.parentNode.removeChild(this);
  }
}

if (!('remove' in Element.prototype)) {
  Element.prototype.remove = nodeRemove;
}
